import React, { Component } from 'react';
import { InputGroup, Button, FormControl } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoffee, fas, faSearch } from '@fortawesome/free-solid-svg-icons'
import Select, { components } from "react-select"
import swal from '@sweetalert/with-react';

class SearchBar extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    handleKeyPress = (event) => {
        if (event.key === 'Enter') {

        }
    }
    searchClick = async (event) => {
        event.preventDefault()
        if (this.props.searchForItem.length == 0) {
            swal("Please Select Search For Option", { icon: "error" })
            return false;
        }
        this.props.searchClick()
    }
    toggleFilter = async (event) => {
        event.preventDefault()
        this.props.toggleFilter()
    }
    clearFilter = async (event) => {
        event.preventDefault()
        this.props.clearFilter()
    }

    handleSelectSearchFor = async (e) => {
        console.log(e)
        let searchFor = ""
        let searchForItem = []
        if (e.length > 0) {
            e.map((item) => {
                searchFor = item.value
                searchForItem.push(item)
            })
        }
        await this.props.SelectSearchForHandler(e.value)
    }
    render() {
        console.log('searchForItem', this.props.searchForItem)
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            container: (provided, state) => ({
                ...provided,
                width: "140px",
            }),
            control: (provided, state) => ({
                ...provided,
                borderRight: 'none',
                borderRadius: "0 0 4px 4px"
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }

        return (
            <form onSubmit={(e) => this.searchClick(e)}>
                <InputGroup className="mb-4">
                    {this.props.ShowSearchFor ?
                        <InputGroup.Append>
                            <Select maxMenuHeight={500} placeholder="Search For" value={this.props.searchForItem} closeMenuOnSelect={true} options={this.props.searchForOptions} onChange={(e) => this.handleSelectSearchFor(e)} styles={customStyles} />
                        </InputGroup.Append>
                        : null
                    }
                    <FormControl
                        type="text"
                        className="form-control"
                        placeholder={this.props.placeholder}
                        aria-label={this.props.label}
                        aria-describedby="basic-addon2"
                        value={this.props.value}
                        onKeyPress={(e) => this.handleKeyPress(e)}
                        onChange={this.props.searchInputHandler}
                        name="search"
                    />
                    <InputGroup.Append>
                        <Button variant="outline-primary" type="submit">
                            <FontAwesomeIcon icon={faSearch} size="lg" />
                            {this.props.btnName}
                        </Button>
                    </InputGroup.Append>
                    {this.props.filter ?
                        <InputGroup.Append>
                            <Button onClick={(e) => this.toggleFilter(e)}   title='Filter'variant="outline-primary"><FontAwesomeIcon icon={"filter"} /></Button>
                        </InputGroup.Append>
                        : null
                    }
                    {this.props.clear ?
                        <InputGroup.Append>
                            <Button onClick={(e) => this.clearFilter(e)} title='Clear All Filter' variant="outline-primary"><FontAwesomeIcon icon={"times"} size="lg" /></Button>
                        </InputGroup.Append>
                        : null
                    }
                </InputGroup>
            </form>
        );
    }
}

export default SearchBar;